<template>
	<v-container grid-list-md>
		<ValidationObserver ref="obs" v-slot="{ invalid }">
			<v-form>
				<v-card>
					<v-card-title primary-title>
						<v-btn icon @click="
							$inertia.visit($route('central.popups.index'))
							"><v-icon>mdi-arrow-left</v-icon></v-btn>
						{{ $t("title.edit_popup") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<form-popup v-model="item" :locations="locations"></form-popup>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="primary" @click.native="submit()" :loading="item.processing" :disabled="invalid">
							<v-icon left>mdi-content-save</v-icon>
							{{ $t("Update") }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</ValidationObserver>
	</v-container>
</template>

<script>
	export default {
		props: ["data", "locations"],
		data() {
			return {
				item: this.$inertia.form(this.data),
			};
		},

		methods: {
			submit() {
				this.item.put(
					this.$route("central.popups.update", {
						popup: this.item.id,
					})
				);
			},
		},
	};
</script>